var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 22,
    viewBox: "0 0 15 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "train"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.21432 13.5001C3.21432 14.0918 3.69402 14.5715 4.28575 14.5715C4.87748 14.5715 5.35718 14.0918 5.35718 13.5001C5.35718 12.9083 4.87748 12.4286 4.28575 12.4286C3.69402 12.4286 3.21432 12.9083 3.21432 13.5001Z",
    fill: "#7E8A96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7142 14.5715C10.1225 14.5715 9.64279 14.0918 9.64279 13.5001C9.64279 12.9083 10.1225 12.4286 10.7142 12.4286C11.3059 12.4286 11.7856 12.9083 11.7856 13.5001C11.7856 14.0918 11.3059 14.5715 10.7142 14.5715Z",
    fill: "#7E8A96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 6.00004C12 5.44776 11.5523 5.00004 11 5.00004L4 5.00004C3.44771 5.00004 3 5.44776 3 6.00004V9.00004C3 9.55233 3.44771 10 4 10L11 10C11.5523 10 12 9.55233 12 9.00004V6.00004Z",
    fill: "#7E8A96"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7385 1.97327C14.0687 2.3111 15 3.50853 15 4.88096L15 14.7857C15 16.4426 13.6569 17.7857 12 17.7857H11.7685L12.7345 20.6837C12.9091 21.2077 12.626 21.774 12.102 21.9487C11.5781 22.1233 11.0117 21.8401 10.8371 21.3162L10.565 20.5L4.5 20.5V20.3049L4.1629 21.3162C3.98825 21.8401 3.42193 22.1233 2.89799 21.9487C2.37404 21.774 2.09089 21.2077 2.26553 20.6837L3.23154 17.7857H3C1.34315 17.7857 0 16.4426 0 14.7857L0 4.88096C0 3.50853 0.931335 2.3111 2.26154 1.97327L5.03846 1.26802C6.65385 0.857763 8.34615 0.857763 9.96154 1.26802L12.7385 1.97327ZM2 14.7857L2 4.88096C2 4.42348 2.31044 4.02434 2.75385 3.91173L5.53077 3.20648C6.82308 2.87828 8.17692 2.87828 9.46923 3.20648L12.2462 3.91173C12.6896 4.02434 13 4.42348 13 4.88096L13 14.7857C13 15.338 12.5523 15.7857 12 15.7857L3 15.7857C2.44771 15.7857 2 15.338 2 14.7857ZM5.10162 18.5L5.23433 18.1019C5.26928 17.9971 5.2859 17.8905 5.28592 17.7857L9.71408 17.7857C9.7141 17.8905 9.73072 17.9971 9.76567 18.1019L9.89838 18.5L5.10162 18.5Z",
    fill: "#7E8A96"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrain);
export default __webpack_public_path__ + "static/media/train.5eb89381.svg";
export { ForwardRef as ReactComponent };